import { render, staticRenderFns } from "./edit-stub.vue?vue&type=template&id=1033cb14"
import script from "./edit-stub.vue?vue&type=script&lang=ts"
export * from "./edit-stub.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports